class SelectReviewRequest {
    SelectReviewURL(code){
        return process.env.REACT_APP_BASEURL+"SelectReview/"+code;
    }
}
export const {SelectReviewURL}=new SelectReviewRequest();